export const RequestType = {
  EMAIL: 'EMAIL',
  LINK: 'LINK',
}
